


const GlobalCurrency = ({ value }) => {
    return (
        <>
            ₹ &nbsp;{value ? parseFloat(value).toFixed(2) : "0.00"}
        </>
    )
}

export default GlobalCurrency;